import React from 'react';
import {TrashIcon} from '@heroicons/react/24/outline';
import {useARStore} from 'stores';

interface IARButtonRemove {}

const ARButtonRemove = ({}: IARButtonRemove) => {
  const modelData = useARStore(s => s.modelData);
  const setModelData = useARStore(s => s.setModelData);
  const models = useARStore(s => s.models);
  const setModels = useARStore(s => s.setModels);
  const modelActive = useARStore(s => s.modelActive);

  const handleRemove = () => {
    modelData && setModelData(null);
    modelActive && setModels(models.filter(m => m.id !== modelActive.id));
  };

  if (!modelData && !modelActive.id) {
    return null;
  }

  return (
    <div className="absolute bottom-36 right-4 flex flex-col gap-1">
      <button
        type="button"
        onClick={handleRemove}
        className="flex justify-center items-center bg-red-400 rounded-full size-16 transition duration-300 active:scale-90">
        <TrashIcon className="size-8 text-white" />
      </button>
      <p className="text-sm text-center text-white drop-shadow-[0_0_1px_black] select-none">REMOVE</p>
    </div>
  );
};

export default React.memo(ARButtonRemove);
